import { ar } from "react-day-picker/locale/ar";
import { de } from "react-day-picker/locale/de";
import { enUS } from "react-day-picker/locale/en-US";

/** Map app locale (i18n) to react-day-picker `locale`; `gr` is German strings in this app. */
export function localeForDayPicker(language) {
  const base = String(language ?? "en").split(/[-_]/)[0].toLowerCase();
  if (base === "ar") return ar;
  if (base === "gr" || base === "de") return de;
  return enUS;
}
